const queryAll = (root: ParentNode, selector: string): Element[] => {
  return Array.from(root.querySelectorAll(selector));
};

const sizeChartTops = document.querySelector('[data-size-chart-tops]'); // tops
const sizeChartPanties = document.querySelector('[data-size-chart-panties]'); // panties

const firstContent = document.querySelector('[data-size-guide-first-content]'); // tops
const secondContent = document.querySelector('[data-size-guide-second-content]'); // panties

const chartButtonsTops = sizeChartTops
  ? queryAll(sizeChartTops, '[data-size-chart-button]')
  : [];
const sizeChartsTops = sizeChartTops
  ? queryAll(sizeChartTops, '[data-size-chart]')
  : [];

const chartButtonsPanties = sizeChartPanties
  ? queryAll(sizeChartPanties, '[data-size-chart-button]')
  : [];
const sizeChartsPanties = sizeChartPanties
  ? queryAll(sizeChartPanties, '[data-size-chart]')
  : [];

const guidePopupTab = queryAll(document, '[data-size-guide-popup-tab]');
const guidePopupContent = queryAll(document, '[data-size-guide-popup-content]');
const guidePopupViewer = queryAll(document, '[data-size-guide-popup-toggler]');
const guidePopup = document.querySelector('[data-size-guide-popup]');

const tabToggler = (tabs: Element[], containers: Element[]): void => {
  if (tabs.length === 0) {
    return;
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      if (tab.classList.contains('active')) {
        return;
      }

      tabs.forEach((tabItem) => tabItem.classList.remove('active'));
      tab.classList.add('active');
      containers.forEach((dataSizeChart) => {
        dataSizeChart.classList.toggle('hidden');
      });
    });
  });
};

const popupViewToggler = (toggleButtons: Element[], popup: Element | null): void => {
  if (toggleButtons.length === 0 || !popup) {
    return;
  }

  toggleButtons.forEach((toggleButton) => {
    toggleButton.addEventListener('click', (event) => {
      event.preventDefault();
      popup.classList.toggle('active');

      if (popup.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    });
  });
};

const videoPlayerHandler = (container: Element | null): void => {
  if (!container) return;

  const videoPlayButton = container.querySelector('.size-guide-popup__video-play');
  const videoNode = container.querySelector('.size-guide-popup__video video');

  const video = videoNode instanceof HTMLVideoElement ? videoNode : null;

  if (!video || !videoPlayButton) return;

  videoPlayButton.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      video.classList.remove('hidden');
    } else {
      video.pause();
      video.classList.add('hidden');
    }
  });
};

window.addEventListener('DOMContentLoaded', () => {
  popupViewToggler(guidePopupViewer, guidePopup);
  tabToggler(chartButtonsTops, sizeChartsTops);
  tabToggler(chartButtonsPanties, sizeChartsPanties);
  tabToggler(guidePopupTab, guidePopupContent);
  videoPlayerHandler(firstContent);
  videoPlayerHandler(secondContent);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && guidePopup && guidePopup.classList.contains('active')) {
      guidePopup.classList.remove('active');
      document.body.style.overflow = 'unset';
    }
  });
});
